import { EmptyIcon } from '@src/components/icons/EmptyIcon';

interface IEmptyListProps {
    message?: string;
    children?: React.ReactNode;
}
export const EmptyList = ({ message, children }: IEmptyListProps) => {
    return (
        <div className="flex flex-col items-center justify-center h-full w-full text-center gap-12">
            <div className="w-36 h-36 flex items-center justify-center bg-[#C9CFF533] rounded-full">
                <EmptyIcon />
            </div>
            <div className="flex flex-col items-center justify-center gap-6">
                <span className="text-2xl text-gray-400">
                    {message || 'No data available'}
                </span>
                {children}
            </div>
        </div>
    );
};
